// extracted by mini-css-extract-plugin
export default {"main":"_7f5243b211","tit":"b7ec15e3aa","maintitle":"_6760bd7b49","ylw":"bee0f8aedb","white":"_47c21aac74","mv_title":"_55ab4dce62","mv_nc":"df5cbaf9ed","mv_in":"_2eae9fde0e"};